import React from 'react';
import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableScheduleAssessment from 'modules/pages/lia/TableScheduleAssessment';

const AssessmentSchedulePage: React.FC = () => {
  const { appName } = useAppName();

  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.assessmentSchedulePage?.title || 'Assessment Schedules'}
          description={
            PAGES[appName]?.assessmentSchedulePage?.description ||
            'Create and manage assessment schedules for your programs. Track upcoming, active, and completed assessments.'
          }
        />

        <TableScheduleAssessment />
      </Stack>
    </Container>
  );
};

export default AssessmentSchedulePage;
